<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">9 o'clock</h1>
        <p id="role">
          Branding<br />2010<br />
          <img src="/images/portfolios/nine/reddot.svg" />
        </p>
      </div>
      <div class="desc">
        <p id="desc">
          <b>Description</b><br />9 o’clock 브랜드는 AM 9시부터 PM 9시까지의
          영업시간에 맞춘 디자인 시스템이 특징이다.
        </p>
        <p id="name">
          <b>Planning:</b> Yuri Ahn, Kiyoung Jung<br /><b>Design:</b> Yuri Ahn,
          Kiyoung Jung
        </p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/nine/01.jpg" />
        <img class="mini" src="/images/portfolios/nine/02.jpg" />
        <img class="mini" src="/images/portfolios/nine/03.jpg" />
        <img class="mini" src="/images/portfolios/nine/04.jpg" />
        <img class="mini" src="/images/portfolios/nine/05.jpg" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('experience-elements')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('nana')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailNineOClock",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/nine/top.jpg");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 100px;
}

.img-contents img.mini {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 50px;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
